export default __webpack_public_path__ + "static/media/chapter11.c40e7521.jpg";